import React from 'react';
import "./Ministries.css"
//import ImageSlider from '../ImageSlider';
import churchImage from './church.jpg' ;
import church1 from '../Images/church-2.jpg';
import womensMinistry from '../Images/women_ministry.jpg';
import mensMinistry from '../Images/mens_ministry.jpg';

const ministryContent = [
    {
        image: `${churchImage}`,
        title : "The Church",
        description :"Our mail service in English and Kiswahili starts @ 10 am every sunday"
    },
    {
        image: "https://media.swncdn.com/cms/CW/faith/31507-biblewithlight-light-bible.1200w.tn.jpg",
        title: "Mid-week Prayers",
        description: "Our Mid-week prayes and Bible study are held every Thursday evening @ 6:00 pm "
    },

    {
        image:`${mensMinistry}`,
        title: "Men's Ministry",
        description: " Please enter mens details here... "
    },
    {
        image: `${womensMinistry}`,
        title: "Women's Ministry",
        description: "Please enter womens details here..."
    },
    {
        image: "https://www.cms-africa.org/images/cma-africa/programmes/youth-ministry-main.jpg",
        title: "Youth Ministry",
        description: "Youth ministry was began on the year 1995 so as to enable fast spread of the gospekl to all nations, the youth always meet Saturday @ 4 pm "
    },
    {
        image: "https://images.squarespace-cdn.com/content/v1/54cd61ece4b004f0c7c1f14c/1452724991008-C3UWS89DH44TS23B5A9K/ke17ZwdGBToddI8pDm48kG87Sfbgg29A4BYEDq3OXvgUqsxRUqqbr1mOJYKfIPR7LoDQ9mXPOjoJoqy81S2I8N_N4V1vUb5AoIIIbLZhVYxCRW4BPu10St3TBAUQYVKcf4OxbJOyh_wHUnyc4kQLQ6SBshRGOku7c30Y_IRDNPta8R2IY5BHMaEj1zOWoDTZ/MBC_OIGC15_3S_WEB-5068.jpg",
        title: "Choir and Music",
        description: "The choir and Music ministry is held every friday evening @ 4:30 pm"
    },
    {
        image: "https://media.swncdn.com/cms/CW/faith/31507-biblewithlight-light-bible.1200w.tn.jpg",
        title: "Sunday school",
        description: "The sunday school classes $ service is at every sunday @ 7:15 am "
    },
    {
        image: "https://images.freeimages.com/images/premium/previews/7167/7167177-french-horn.jpg",
        title: "MCs for Service",
        description: ` Onesmus Mutunga , Daniel Ngwasi, Barnabas Muoki, Andrew Muoki`,
    }

]

function Ministries() {
    return (
        <div className="ministries">
           
            <div className="background-image">
                <img src={church1} alt=""/>
                <h3>Hello world, Let's spread the gospel and win more souls to the lord</h3>
            </div>
            <div className="ministriesBody">
                {ministryContent.map((item, index) => (
                    <div key={index} className="ministry">
                        <img src={item.image} alt={item.title}/>
                        <div className="ministryDescription">
                            <h3>{item.title}</h3>
                            <p>{item.description}</p>
                        </div>
                    </div>
                ))}

            </div>
            
        </div>
    )
}

export default Ministries
